import CommunitySection from "@/components/site/CommunitySection";
import RegistrationForm from "@/components/site/RegistrationForm";
import usePageTitle from "@/hooks/usePageTitle";

export default function CommunityPage() {
  usePageTitle("Community Initiatives · Maqam");
  return (
    <div data-testid="page-community">
      <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <span className="overline">Community Initiatives</span>
          <h1 className="font-serif text-5xl md:text-7xl text-navy mt-3 leading-[1.02] tracking-tight max-w-3xl">
            Faith-rooted programs<br /> for our community.
          </h1>
          <p className="mt-6 text-[var(--maqam-muted)] max-w-2xl leading-relaxed">
            Maqam exists year-round for the community — not only for the Umrah journey.
            From New Muslim support to seminars and youth programs, our initiatives are
            grounded in classical knowledge and modern community needs.
          </p>
        </div>
      </section>
      <CommunitySection full />
      <RegistrationForm variant="contact" />
    </div>
  );
}
